import { applyMiddleware, createStore } from 'redux'
import { composeWithDevTools } from 'redux-devtools-extension/developmentOnly'
import { persistReducer, persistStore } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import createSagaMiddleware from 'redux-saga'

export default ({ rootReducer, rootSaga, preloadedState = {} }: any) => {
  const sagaMiddleware = createSagaMiddleware()
  const persistConfig = {
    key: 'root',
    storage,
    whitelist: ['auth']
  }

  const persistedReducer = persistReducer(persistConfig, rootReducer)

  const store = createStore(
    persistedReducer,
    preloadedState,
    composeWithDevTools(applyMiddleware(sagaMiddleware))
  )
  const persistor = persistStore(store)
  sagaMiddleware.run(rootSaga)

  return { store, persistor }
}
